module.exports = __webpack_public_path__ + "static/m-JVelazquez-708f1c6708c962a6a7ed29e714b0572a.jpg";